module.exports = __webpack_public_path__ + "prod/1.42.2/img/goverment-icon.73b7505e.png";